/*
	ACTIONS
*/
//------------------------------------------------------------
// OPEN DIRECTORY
//------------------------------------------------------------

const openDirectory = ({state, commit}, target) => {

	// var fileSystem = state.fileSystem;
	// var uid = payload.uid;
	// var id = payload.id;
	// var isForeign = payload.isForeign; // fileSystem can "plug" into a second one for hacking

	// maybe the fileSystem can be temporarily stored in system as foreign, so access
	// var fileSystem = state['fileSystem']find(fileSystem => fileSystem.uid === payload.uid);

    commit('OPEN_DIRECTORY', target);
}

//------------------------------------------------------------
// SELECT ICON
// simply makes item active or 'highlighted' to indicate use
//------------------------------------------------------------

const selectIcon = ({state, commit}, target) => {
	commit('DESELECT_ICONS');
    commit('SELECT_ICON', target);
}

//------------------------------------------------------------
// DESELECT ALL ICONS
//------------------------------------------------------------

const deselectIcons = ({state, commit}, target) => {
    commit('DESELECT_ICONS', target);
}

//------------------------------------------------------------
// UPDATE ICON POSITION
//------------------------------------------------------------

const updateIconPosition = ({commit}, target) => {
    commit('UPDATE_ICON_POSITION', target);
}

//------------------------------------------------------------
// EXPORT
//------------------------------------------------------------

export default {
	openDirectory,
	selectIcon,
	deselectIcons,
	updateIconPosition
}
//===========================================
//
//===========================================